const TABLETBREAK = 900;
const MAXWRAP = 1400;
const BANKNAME = "First State Bank of St. Charles";
const CONTACTLINK = "/about-us/contact/";